import { DataTemplateTypes } from './data-template-types.enum';
import { ISelectItem } from './select-item';
import { BaseFile } from '@shared/models/base-file';
import { TranslatedValue } from './translated-value';

export enum DataRequestStatus {
  NotStarted = 1,
  InProgress = 2,
  InReview = 3,
  CorrectionRequired = 4,
  Reviewed = 5,
  Completed = 6,
}

export interface DataRequest {
  id: number;
  dataTemplateId: number;
  partnerInstitutionId: number;
  name: string;
  purpose: ISelectItem;
  dueDate: string;
  reportingCycle: string | null;
  status: { id: DataRequestStatus; name: string };
  countryName: string;
  partnerInstitutionName: string;
  fundType: { id: number; name: string };
  overdue: boolean;
  histories: DataRequestHistory[];
  previousDataRequestId?: number;
  files: BaseFile[];
  reportDate: string;
  energyDataLastFetchDate: string;
  locked: boolean;
  dataTemplateTypeId: DataTemplateTypes;
  waived?: boolean;
  /**
   * Completed – Non-Compliant (No Submission): closed by an internal user because the PI never
   * submitted. Distinct from `waived` (an accepted non-submission). The justification, actor and
   * timestamp live in the request histories (Completed entry).
   */
  isNonCompliant?: boolean;
  nonCompliantJustification?: string;
  questionnaireTemplateId?: number;
  translatedName: TranslatedValue;
  canBePrefilled?: boolean;
  prefilledAnswersCount?: number;
  lastSubmissionDate: string;
}

export interface DataRequestHistory {
  dataRequestId: number;
  status: ISelectItem;
  comment: string;
  createdDate: string;
  createdBy: ISelectItem;
}
